var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeapLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 43,
    viewBox: "0 0 157 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LEAP-LOGO"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6835 40.0303V31.2368H6.87355V0H0V40.0303H23.6835ZM111.598 0V40.0303H121.654V22.0708H130.059C140.34 22.0708 145.518 14.6933 145.518 6.1979C145.518 4.02374 145.179 1.9228 144.502 0H132.224C134.107 1.13898 135.237 3.32203 135.237 6.1979C135.237 10.5201 132.685 13.2774 128.858 13.2774H121.654V0H111.598ZM76.1829 0H94.1246L106.091 40.0303H95.1347L92.8083 31.2368H77.4241L75.0977 40.0303H64.2163L76.1829 0ZM31.4133 0H41.4693V10.3711H59.5551V19.1645H41.4693V31.2368H60.0804V40.0303H31.4133V0ZM85.1537 0.832413L79.4503 22.4434H90.8571L85.1537 0.832413ZM157 35.1119C157 38.2418 154.373 40.85 151.222 40.85C148.07 40.85 145.368 38.2418 145.368 35.1119C145.368 31.982 148.07 29.2993 151.222 29.2993C154.373 29.2993 157 31.982 157 35.1119Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeapLogo);
export default __webpack_public_path__ + "static/media/leap-logo.a40c4896b56a0e80e955b444ece3aa48.svg";
export { ForwardRef as ReactComponent };